(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/prolong-empty.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/prolong-empty.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.ProlongEmpty = Marionette.View.extend({
    template: function(data) {
      return svs.maltipset.templates.prolong_empty(data);
    }
  });
})(Backbone, _, svs);


 })(window);